<template>
  <div class="login">
    <div class="login-content">
      <div class="login-container">
        <div class="header">
          <img src="@/assets/logos/beta-logo.svg">
          <div
            v-if="!hideBackButton"
            style="width: fit-content"
          >
            <button
              class="button-tertiary--small"
              @click="goBack"
            >
              <i class="bi bi-arrow-left" />
              Back to Login
            </button>
          </div>
        </div>
        <CalicoBanner
          v-if="error"
          variant="error"
          fixed
        >
          <span class="body--medium">{{ error }}</span>
        </CalicoBanner>
        <CalicoBanner
          v-else-if="success"
          variant="success"
          fixed
        >
          <span class="body--medium">{{ success }}</span>
        </CalicoBanner>
        <form
          class="form"
          @submit.prevent="onSubmit"
        >
          <slot :validate="validate" />
        </form>
      </div>
      <CopyWrite />
    </div>
  </div>
</template>

<script>
import { useForm } from 'vee-validate'
import CopyWrite from '@/components/calico/copywrite/index.vue'
import CalicoBanner from '@/components/calico/banner/index.vue'
import { RoutesEnum } from '@/enums'

export default {
  name: 'LoginTemplate',
  components: {
    CopyWrite,
    CalicoBanner
  },
  props: {
    hideBackButton: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: ""
    },
    success: {
      type: String,
      default: ""
    }
  },
  emits: ['submit'],
  data() {
    const { validate } = useForm();
    return { validate };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.validate)
    },
    goBack() {
      this.$auth.signOut();
      this.$router.push(RoutesEnum.LOGIN);
    }
  }
}
</script>


<style lang="scss">
.login {
  @include stack-space($space-none);
  height: 100vh;
  width: 100%;
  align-items: center;
  background: $color-background-secondary;
  overflow: auto;

  .login-content {
    @include inset-space($space-large);
    @include stack-space($space-xlarge);
    width: 100%;
    max-width: 730px;

    .login-container {
      @include stack-space($space-xlarge);
      align-items: center;

      .calico-banner {
        max-width: 360px;
      }

      .header {
        @include stack-space($space-medium);
        align-items: center;
        width: 203px;
        padding-top: $space-xxlarge;
      }

      .form {
        @include stack-space($space-medium);
        align-items: center;
        width: 100%;
        max-width: 360px;
      }
    }
  }
}
</style>
